'use client';

import { ChangeEvent, FC } from 'react';

import { Input } from '@/shared/ui';

interface EventFormFieldsProps {
  className: string;
  name: string;
  phone: string;
  email: string;
  nameError?: string;
  phoneError?: string;
  emailError?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onPhoneChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const EventFormFields: FC<EventFormFieldsProps> = ({
  className,
  name,
  phone,
  email,
  nameError,
  phoneError,
  emailError,
  onChange,
  onPhoneChange,
}) => {
  return (
    <div className={className}>
      <Input
        error={nameError}
        label="Имя"
        labelVariant="grey"
        name="name"
        value={name}
        onChange={onChange}
      />
      <Input
        error={phoneError}
        label="Телефон"
        labelVariant="grey"
        name="phone"
        type="tel"
        value={phone}
        onChange={onPhoneChange}
      />
      <Input
        error={emailError}
        label="E-mail"
        labelVariant="grey"
        name="email"
        value={email}
        onChange={onChange}
      />
    </div>
  );
};

export default EventFormFields;
